<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="指定颜色尺码汇出"
      :visible.sync="visible"
      width="50%"
      center
      @close="handleClose"
      class="amazon_category_dialog"
    >
      <div>
        <el-table
          :data="tables"
          :header-cell-style="{ 'text-align': 'center' }"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="id" label="序号" width="60">
            <template slot-scope="scope">
              <div style="overflow: hidden;text-align:center;">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="产品信息" width="260">
            <template slot-scope="scope">
              <div style="overflow: hidden;text-align:center;">
                <div class="avator">
                  <img :src="scope.row.picUrl" />
                </div>
                <div class="info">
                  <div>{{ scope.row.designId }}</div>
                  <div>{{ scope.row.designProName }}</div>
                  <div>{{ scope.row.designEngProName }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="">
            <template slot-scope="scope">
              <div style="overflow: hidden">
                颜色：<el-checkbox-group
                  @change="handleChangeColor(scope.row)"
                  v-model="scope.row.checkColor"
                >
                  <el-checkbox
                    v-for="record in scope.row.colorList"
                    :key="record"
                    :label="record"
                    >{{ record }} ({{
                      dictMap["language"][record]
                    }})</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div style="overflow: hidden">
                尺码：<el-checkbox-group
                  @change="handleChangeSize(scope.row)"
                  v-model="scope.row.checkSize"
                >
                  <el-checkbox
                    v-for="record in scope.row.sizeList"
                    :key="record"
                    :label="record"
                    >{{ record }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" size="small"
          >确 定</el-button
        >
        <el-button @click="handleClose" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`修改${this.priceType === 'quantity' ? '库存' : '价格'}`"
      :visible.sync="showPriceDialog"
      width="560px"
      @close="handleClosePriceDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        {{ this.priceType === "quantity" ? "库存" : "价格" }}：<el-input
          v-model.trim="priceModify"
          onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
          :title="`请输入${this.priceType === 'quantity' ? '库存' : '价格'}`"
          size="mini"
          style="width: 450px"
        ></el-input>
      </el-row>

      <div
        slot="footer"
        style="text-align: right !important"
        class="dialog-footer"
      >
        <el-button @click="handleClosePriceDialog" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleUpdatePrice" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSkuList } from "@/api/template/template"
import { mapGetters } from "vuex"

export default {
  name: "PriceConfigDialog",
  data() {
    return {
      tables: [],
      showPriceDialog: false,
      priceModify: "",
      priceType: "",
      isSet: false,
      skuList: [],
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible && !this.isSet) {
          this.getSkuList()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSubmit() {
      let skuList = []
      for (let record of this.tables) {
        if(record.checkColor.length == 0){
          this.msgError(record.designProName + '颜色不同为空')
          return
        }
        if(record.checkSize.length == 0){
          this.msgError(record.designProName + '尺码不同为空')
          return
        }
        for (let sku of record.skuList) {
          if (
            record.designId == sku.designId &&
            record.checkColor.includes(sku.color) &&
            record.checkSize.includes(sku.size)
          ) {
            skuList.push(sku)
          }
        }
      }

      this.isSet = true
      this.$emit("change", false)
      this.$emit("update", skuList)
    },
    handleUpdatePrice() {
      for (let record of this.tables) {
        for (let item of record.skuList) {
          if (this.priceType === "price") {
            item.price = this.priceModify
          } else if (this.priceType === "quantity") {
            item.quantity = this.priceModify
          }
        }
      }
      this.showPriceDialog = false
    },
    handleChangeColor(row) {},
    handleChangeSize(row) {},
    handleShowPriceDialog(priceType) {
      this.priceModify = ""
      this.showPriceDialog = true
      this.priceType = priceType
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {},
    handleClosePriceDialog() {
      this.showPriceDialog = false
    },
    async getSkuList() {
      let designId = this.$route.query.designId
      let result = await getSkuList({ designId })
      let tables = []
      for (let record of result.rows) {
        let table = {
          designEngProName: record.designEngProName,
          designId: record.designId,
          designProName: record.designProName,
          picUrl: record.picUrl,
          skuList: record.skuList,
          colorList: [],
          sizeList: [],
          checkColor: [],
          checkSize: [],
        }
        for (let item of table.skuList) {
          if (!table.colorList.includes(item.color)) {
            table.colorList.push(item.color)
            table.checkColor.push(item.color)
          }
          if (!table.sizeList.includes(item.size)) {
            table.sizeList.push(item.size)
            table.checkSize.push(item.size)
          }
        }
        tables.push(table)
      }
      this.tables = tables
    },
    handleClose() {
      this.$emit("change", false)
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 119px;
}
.avator {
}
.info {
  margin-left: 4px;
}
.amazon_category_dialog ::v-deep .el-dialog__footer {
  text-align: right;
}
</style>
